import { render, staticRenderFns } from "./scorecard-standard-orders.vue?vue&type=template&id=a170cb4a&scoped=true"
import script from "./scorecard-standard-orders.vue?vue&type=script&lang=js"
export * from "./scorecard-standard-orders.vue?vue&type=script&lang=js"
import style0 from "./scorecard-standard-orders.vue?vue&type=style&index=0&id=a170cb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a170cb4a",
  null
  
)

export default component.exports